import { FC, ReactNode } from "react";
import { Box, useTheme, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./Header";
import Sidebar from "./Sidebar";

interface SidebarLayoutProps {
  children?: ReactNode;
}
const HeaderBlock = styled(Box)(
  ({ theme }) => `
   position: -webkit-sticky; /* For Safari support */
  position: sticky;
  top: 0;
  z-index: 1000; /* Ensures it's on top */
  background: ${theme.header.background};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`
);

const ContentBlock = styled(Box)(() => ({
  height: "max-content",
  padding: "20px 20px 60px 20px",
}));

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();

  return (
    <>
      <Box>
        <Sidebar />
        <Box
          sx={{
            [theme.breakpoints.up("lg")]: {
              ml: `${theme.sidebar.width}`,
            },
          }}
        >
          <HeaderBlock display="block">
            <Header />
          </HeaderBlock>
          <ContentBlock display="block">
            <Outlet />
          </ContentBlock>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
